<div class="row nested-row tags">
  <div class="col-12">
    <span class="bold">Tags:</span>
    <ul class="list-inline d-inline-block ml-3 mb-0">
      <li class="list-inline-item mb-2" *ngFor="let item of tags">
        <span class="bold pill-reference">{{item.text}}</span>
      </li>
    </ul>
  </div>
</div>
